import {ChangeEvent, FC} from 'react';
//mui
import {Box, Switch as MuiSwitch, SwitchProps, SxProps, Theme} from '@mui/material';
//formik
import {FieldInputProps, FormikProps} from 'formik';

interface ExtendedSelectProps extends Omit<SwitchProps, 'form'> {
	field?: FieldInputProps<string | number>;
	form?: FormikProps<any>;
	parentClassName?: SxProps<Theme>;
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Switch: FC<ExtendedSelectProps> = ({field, form, parentClassName, onChange, ...rest}) => {
	const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
		if (onChange) {
			onChange(event);
		} else if (form && field) {
			form.setFieldValue(field.name, event.target.checked);
		}
	};

	return (
		<Box sx={parentClassName}>
			<MuiSwitch {...rest} onChange={changeHandler} />
		</Box>
	);
};

export default Switch;
